import { defineComponent as _defineComponent } from 'vue'
import { inject, Ref, watch } from 'vue';

import {
  NavBar,
  HelperViewContextual,
  ButtonContainer,
  ButtonPrimary,
  ButtonSecondary
} from '@warrenbrasil/nebraska-web';
import { SideSheet } from '@/modules/common/components/SideSheet';
import { BackButton } from '@/modules/common/components/buttons';

import { removeBodyScroll } from '@/modules/common/helpers/browser';

interface EmitEvents {
  (event: 'close'): void;
}
interface Props {
  isOpen: boolean;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'DeallocateLimit',
  props: {
    isOpen: { type: Boolean }
  },
  emits: ["close"],
  setup(__props: any, { emit }: { emit: ({
  (event: 'close'): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  isOpen: boolean;
};





const fetchUpdateLimits = inject(
  'fetchUpdateLimits',
  async (isDeallocate: boolean) => ({ isDeallocate })
);
const updateDataForm = inject(
  'updateDataForm',
  (key: string, value: object) => ({
    key,
    value
  })
);

const dataForm = inject('dataForm') as Ref<{ isUpdatingLimits: boolean }>;

async function confirmDealocate() {
  updateDataForm('balance', { value: 0, formatted: '' });
  updateDataForm('drawdown', { value: 0, formatted: '' });

  await fetchUpdateLimits(true);

  emit('close');
}

watch(
  () => props.isOpen,
  _isOpen => {
    removeBodyScroll();
  }
);

return { __sfc: true,emit, props, fetchUpdateLimits, updateDataForm, dataForm, confirmDealocate, NavBar, HelperViewContextual, ButtonContainer, ButtonPrimary, ButtonSecondary, SideSheet, BackButton }
}

})